module.exports = __webpack_public_path__ + "ab43daf83da8bb90576685917d71a088.jpg";